var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk2712128430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.5 30",
    style: {
      enableBackground: "new 0 0 200.5 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 11.6002 62.1118)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 46.5938 123.3837)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.6,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,30h-29.7V0.4h29.7V30z M114.9,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6,26h-22.5V4h22.5V26z M118.2,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 0.1704 15.984)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.8768 9.6282)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,30H0V0.4h29.7V30z M1.1,28.9h27.5V1.5H1.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26H3.9V4h22.5V26z M5,24.8h20.2V5.1H5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.1,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 18.3115 88.9637)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.4,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 75.2477 172.8768)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.6,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5,30h-29.7V0.4h29.7V30z M171.9,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,26h-22.5V4h22.5V26z M175.3,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 15.1663 40.9767)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.9,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -5.1141 23.7348)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,30H28.3V0.4h29.7V30z M29.5,28.9h27.5V1.5H29.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,26H32.2V4h22.5V26z M33.4,24.8h20.2V5.1H33.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 30.3071 66.2109)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.3143 37.9807)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.3,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,30H56.9V0.4h29.7V30z M58.1,28.9h27.5V1.5H58.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3,26H60.8V4h22.5V26z M62,24.8h20.2V5.1H62V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 45.3029 91.2036)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.8,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 2.4484 52.0873)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,30H85.2V0.4H115V30z M86.4,28.9h27.5V1.5H86.4V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6,26H89.2V4h22.5V26z M90.3,24.8h20.2V5.1H90.3V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 14.9471 75.503)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.7,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 60.8824 148.065)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9,30h-29.7V0.4h29.7V30z M143.3,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,26h-22.5V4H168V26z M146.7,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.5,28.5c-0.2,0-0.4-0.1-0.5-0.4l-1.8-4.2c-0.1-0.3,0-0.6,0.3-0.7c0.3-0.1,0.6,0,0.7,0.3l1.8,4.2c0.1,0.3,0,0.6-0.3,0.7 L141.5,28.5z M138.5,21.1c-0.2,0-0.4-0.1-0.5-0.4l-1.8-4.2c-0.1-0.3,0-0.6,0.3-0.7c0.3-0.1,0.6,0,0.7,0.3l1.8,4.2 c0.1,0.3,0,0.6-0.3,0.7L138.5,21.1z M135.4,13.8c-0.2,0-0.4-0.1-0.5-0.4l-1.8-4.2c-0.1-0.3,0-0.6,0.3-0.7c0.3-0.1,0.6,0,0.7,0.3 l1.8,4.2c0.1,0.3,0,0.6-0.3,0.7L135.4,13.8z M132.3,6.4c-0.2,0-0.4-0.1-0.5-0.4l-1.8-4.2c-0.1-0.3,0-0.6,0.3-0.7 c0.3-0.1,0.6,0,0.7,0.3l1.8,4.2c0.1,0.3,0,0.6-0.3,0.7L132.3,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,29.6l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8l2.2-4c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8l-2.2,4 C114.6,29.5,114.4,29.6,114.2,29.6z M118.1,22.7l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8l2.2-4c0.2-0.3,0.5-0.4,0.8-0.2 c0.3,0.2,0.4,0.5,0.2,0.8l-2.2,4C118.5,22.6,118.3,22.7,118.1,22.7z M122,15.7l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8l2.2-4 c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8l-2.2,4C122.4,15.6,122.2,15.7,122,15.7z M125.9,8.7l-0.3-0.1 c-0.3-0.2-0.4-0.5-0.2-0.8l2.2-4c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8l-2.2,4C126.3,8.6,126.1,8.7,125.9,8.7z  M129.8,1.8l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8l0.4-0.6c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8l-0.4,0.6 C130.2,1.7,130,1.8,129.8,1.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk2712128430);
export default __webpack_public_path__ + "static/media/AK2_7_1212843_0.5a2b051c306785a3709abb1319cd5c27.svg";
export { ForwardRef as ReactComponent };